import React, { useEffect, useState, useRef } from "react";
import { useKeycloak } from "@react-keycloak/web";
import {
  Row,
  Col,
  Space,
  Button,
  Image,
  Dropdown,
  Card,
  Modal,
  Typography,
  Form,
  Input,
  message, notification,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { LogoutOutlined, UserOutlined, LockOutlined,KeyOutlined, WalletOutlined } from "@ant-design/icons";
import loginLogo from "../../../assets/img/logo.png";
import { decodeToken } from 'react-jwt';
import {
  BellIcon,
  LifeGuardIcon,
  DividerIcon,
  UserSvgIcon,
} from "../../atoms/CustomIcons";
import {useDispatch, useSelector} from "react-redux";
import {setUserOTP, verifyOrDisableOTP} from "../../modules/SubUsers/ducks/services";
import {setUserData} from "Modules/Login/ducks/action";
import { getClientDetails, fetchClientBalance } from "../../modules/Billing/ducks/action";
import axiosInterceptor from "../../../configs/axiosIntereptor";

const { Text } = Typography;
export default (props) => {
  const { keycloak, initialized } = useKeycloak();
  const dispatch = useDispatch();
  let token = decodeToken(keycloak?.token);
  let role = token?.realm_access?.roles?.includes("paid_reseller");
  const userData = useSelector((state) => state.userReducer.userData);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const eventSourceRef = useRef(null);

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      setNotificationsLoading(true);
      const response = await axiosInterceptor.get('/api/notifications?limit=50');
      if (response?.data?.header?.response_code === 1 && response?.data?.body) {
        setNotifications(response.data.body);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setNotificationsLoading(false);
    }
  };

  // Mark notification as read
  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await axiosInterceptor.put(`/api/notifications/${notificationId}/read`);
      // Check if successful
      if (response?.data?.header?.response_code === 1) {
        // Update local state
        setNotifications(prev => 
          prev.map(notif => 
            notif.id === notificationId ? { ...notif, status: 'read' } : notif
          )
        );
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      const response = await axiosInterceptor.put('/api/notifications/read-all');
      // Check if successful
      if (response?.data?.header?.response_code === 1) {
        setNotifications(prev => 
          prev.map(notif => ({ ...notif, status: 'read' }))
        );
      }
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };

  const history = useHistory();
  const location = useLocation();

  const handleSupportClick = () => {
    const supportEmail = "support@purewl.com";
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}`;

    const mailtoLink = document.createElement("a");
    mailtoLink.href = `mailto:${supportEmail}`;
    mailtoLink.style.display = "none";

    // Append the mailto link to the body to open the default mail client
    document.body.appendChild(mailtoLink);
    mailtoLink.click();

    // Remove the appended mailto link
    document.body.removeChild(mailtoLink);

    // Open Gmail in a new tab
    window.open(gmailLink, "_blank");

  };
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const result = await disableOTP(values);
      if (result) {
        notification.success({
          message: 'Disable OTP',
          description: 'User OTP has been successfully disabled',
          placement: 'bottomRight',
        });
        form.resetFields();
        setIsModalVisible(false);
        dispatch(setUserData()); // Dispatch the action to set user data in Redux
      } else {
        notification.error({
          message: 'Disable OTP',
          description: 'Failed to disable OTP',
          placement: 'bottomRight',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.message,
        placement: 'bottomRight',
      });
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onOTPHandler = () => {
    if(!userData?.totp){
      setOTP().then(r =>window.location.reload());
    }
    else {
      setIsModalVisible(true);
    }
  };
  const setOTP = async () => {
    const response =  await setUserOTP();
    return response
  };
  const disableOTP = async (values) => {
    try {
      const payload = {
        totp: values.totp,
        password: values.password,
        disable_otp: true
      }
      const response = await verifyOrDisableOTP(payload);
      if (response?.data?.status == 200) {
        return true
      } else {
        notification.error({
          message: 'OTP Verification Failed',
          description: 'The provided OTP or password is incorrect',
          placement: 'bottomRight',
        });
        return false;
      }

    }
    catch (error) {
    }
  };
  
  const items = () => {
    const onLogoutHandler = () => {
      localStorage.clear();
      keycloak.logout();
    };

    let Comp = [
      role && {
        key: "1",
        label: (
          <Button
            onClick={() => history.push("/dashboard/profile")}
            type="link"
            className="btn-link"
            icon={<UserOutlined />}
          >
            Profile
          </Button>
        ),
      },
      {
        key: "2",
        label: (
          <Button
            onClick={() => history.push("/change-password")}
            type="link"
            className="btn-link"
            icon={<LockOutlined />}
          >
            Change Password
          </Button>
        ),
      },
      {
        key: "3",
        label: (
            <Button
                onClick={onOTPHandler}
                type="link"
                className="btn-link"
                icon={<KeyOutlined />}
            >
              {userData?.totp ? 'Disable OTP' : 'Enable OTP'}
            </Button>
        ),
      },
      {
        key: "4",
        label: (
          <Button
            onClick={onLogoutHandler}
            type="link"
            className="btn-link"
            icon={<LogoutOutlined />}
          >
            Logout
          </Button>
        ),
      },

    ];
    return Comp;
  };

  // Format timestamp
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    try {
      return new Date(timestamp).toLocaleString();
    } catch {
      return '';
    }
  };

  // Get color for notification type
  const getNotificationColor = (type) => {
    switch (type) {
      case 'export_started':
        return '#1890ff'; // Blue
      case 'export_success':
        return '#52c41a'; // Green
      case 'export_failed':
        return '#ff4d4f'; // Red
      default:
        return '#666'; // Gray
    }
  };

  // Build notification dropdown items
  const items2 = notifications.length > 0 ? [
    ...notifications.slice(0, 10).map((notif) => ({
      key: notif.id || notif.timestamp,
      label: (
        <div 
          style={{ 
            padding: '8px 0',
            borderBottom: '1px solid #f0f0f0',
            cursor: 'pointer',
            backgroundColor: notif.status === 'unread' ? '#f6f8fa' : 'transparent'
          }}
          onClick={() => {
            if (notif.id && notif.status === 'unread') {
              markNotificationAsRead(notif.id);
            }
          }}
        >
          <div style={{ 
            fontWeight: notif.status === 'unread' ? 600 : 400, 
            marginBottom: 4, 
            color: getNotificationColor(notif.type) 
          }}>
            {notif.title}
            {notif.status === 'unread' && (
              <span style={{ 
                display: 'inline-block',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#1890ff',
                marginLeft: '8px'
              }} />
            )}
          </div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
            {notif.message}
          </div>
          {(notif.timestamp || notif.created_at) && (
            <div style={{ fontSize: 11, color: '#999' }}>
              {formatTimestamp(notif.timestamp || notif.created_at)}
            </div>
          )}
        </div>
      ),
    })),
    {
      key: 'mark-all-read',
      label: (
        <div style={{ padding: '8px 0', textAlign: 'center', borderTop: '1px solid #f0f0f0' }}>
          <Button type="link" size="small" onClick={markAllAsRead}>
            Mark All as Read
          </Button>
        </div>
      ),
    },
  ] : [
    {
      key: "1",
      label: <Text className="empty-notification">No New Notifications</Text>,
    },
  ];
  const items3 = [
    {
      key: "3",
      label: <Text className="empty-notification">Set User Permissions</Text>,
    },
  ];

  const headers1 = {
    "Content-Type": "application/json",
  };
  // useEffect(() => {
  //   fetch(`${BASE_URL}/api/app-status/${userDetail?.uuid}`, {
  //     method: "GET",
  //     headers1,
  //   })
  //     .then((response) => response.json())
  //     .catch((error) => message.error("Something went wrong"))
  //     .then((json) => {
  //       setStatus(json.data);
  //     });
  // }, []);
  const clientBalance = useSelector(state => state.billingReducer.clientBalance);

  useEffect(() => {
    if (keycloak?.tokenParsed?.whmcs_client_id) {
      dispatch(fetchClientBalance());
    }
  }, [location.pathname, keycloak?.tokenParsed?.whmcs_client_id, dispatch]);

  // Fetch notifications on mount
  useEffect(() => {
    if (keycloak?.token && initialized) {
      fetchNotifications();
    }
  }, [keycloak?.token, initialized]);

  // SSE connection for real-time notifications
  useEffect(() => {
    if (!keycloak?.token || !initialized) {
      return;
    }

    const BASE_URL = process.env.REACT_APP_BASE_URL || '';
    const token = keycloak.token;
    
    // Connect to SSE endpoint
    const eventSource = new EventSource(`${BASE_URL}/api/notifications/stream?token=${encodeURIComponent(token)}`);
    eventSourceRef.current = eventSource;

    // Handle connection open
    eventSource.onopen = () => {
      // console.log('✅ SSE connection opened');
      // console.log('SSE URL:', `${BASE_URL}/api/notifications/stream?token=${token.substring(0, 20)}...`);
    };
    
    // Listen for 'connected' event from server
    eventSource.addEventListener('connected', (event) => {
      // console.log('✅ SSE connected event received:', event.data);
    });

    // Handle incoming notifications
    eventSource.addEventListener('export_started', (event) => {
      const notificationData = JSON.parse(event.data);
      const notifWithId = { ...notificationData, id: notificationData.id || Date.now(), status: 'unread' };
      setNotifications(prev => [notifWithId, ...prev].slice(0, 50)); // Keep last 50
      // Refresh from API to get the saved notification with proper ID
      fetchNotifications();
      
      // Show browser notification
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification(notificationData.title, {
          body: notificationData.message,
          icon: '/favicon.ico'
        });
      }
      
      // Notification will appear in header notification tab only (no popup)
    });

    eventSource.addEventListener('export_success', (event) => {
      const notificationData = JSON.parse(event.data);
      const notifWithId = { ...notificationData, id: notificationData.id || Date.now(), status: 'unread' };
      setNotifications(prev => [notifWithId, ...prev].slice(0, 50)); // Keep last 50
      // Refresh from API to get the saved notification with proper ID
      fetchNotifications();
      
      // Show browser notification
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification(notificationData.title, {
          body: notificationData.message,
          icon: '/favicon.ico'
        });
      }
      
      // Notification will appear in header notification tab only (no popup)
    });

    eventSource.addEventListener('export_failed', (event) => {
      const notificationData = JSON.parse(event.data);
      const notifWithId = { ...notificationData, id: notificationData.id || Date.now(), status: 'unread' };
      setNotifications(prev => [notifWithId, ...prev].slice(0, 50)); // Keep last 50
      // Refresh from API to get the saved notification with proper ID
      fetchNotifications();
      
      // Show browser notification
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification(notificationData.title, {
          body: notificationData.message,
          icon: '/favicon.ico'
        });
      }
      
      // Notification will appear in header notification tab only (no popup)
    });

    // Handle connection errors
    eventSource.onerror = (error) => {
      console.error('SSE connection error:', error);
      console.error('SSE readyState:', eventSource.readyState);
      // EventSource states: 0=CONNECTING, 1=OPEN, 2=CLOSED
      if (eventSource.readyState === EventSource.CLOSED) {
        // console.log('SSE connection closed, will attempt to reconnect...');
      }
      // EventSource will automatically reconnect
    };

    // Request browser notification permission
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    // Cleanup on unmount
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, [keycloak?.token, initialized]);

  return (
    <Card bordered={false} className="c-header">
      <Row gutter={[24, 15]} align="middle">
        <Col span={12} xs={24} sm={24} md={24} lg={12} xl={12}>
          <Image
            width={135}
            preview={false}
            alt="PureVpn"
            src={loginLogo}
            // onClick={() => history.push('/dashboard')}
          />
        </Col>
        <Col
          span={12}
          className="text-right"
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
        >
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            {/* Balance Dropdown */}
            {clientBalance !== null && (
              <Dropdown
                placement="bottomRight"
                overlay={
                  <Card bordered style={{ minWidth: 240, textAlign: 'center', boxShadow: '0 2px 8px rgba(124,58,237,0.08)' }}>
                    <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>Balance</div>
                    <div style={{ color: '#7c3aed', fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
                      ${Number(clientBalance).toFixed(2)}
                    </div>
                    <div style={{ color: '#888', fontSize: 13 }}>This is your current available credit.</div>
                  </Card>
                }
                trigger={["click"]}
              >
                <Button
                  type="default"
                  style={{
                    borderRadius: 20,
                    border: '1px solid #7c3aed',
                    background: '#fff',
                    color: '#7c3aed',
                    fontWeight: 700,
                    fontSize: 16,
                    padding: '4px 18px',
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: '0 2px 8px rgba(124,58,237,0.04)',
                    marginRight: 8
                  }}
                  icon={<WalletOutlined style={{ fontSize: 20, marginRight: 8 }} />}
                >
                  ${Number(clientBalance).toFixed(2)}
                </Button>
              </Dropdown>
            )}
            <Space size={25} className="pl-0">
              {/* <Button
                onClick={onOTPHandler}
                type="link"
                className="btn-link"
                icon={<KeyOutlined />}
              >
              </Button>
              <DividerIcon /> */}

              { token?.realm_access?.roles?.includes("paid_reseller") &&
                !token?.realm_access?.roles?.includes("sub_user") && (
                <Button
                    onClick={() => history.push("/acl")}
                    type="link"
                    className="btn-link"
                    icon={<LockOutlined />}
                >
                </Button>
              )}
              {/* <LifeGuardIcon /> */}
              <DividerIcon />
              <Button
                type="link"
                className="btn-link"
                icon={<LifeGuardIcon />}
                onClick={handleSupportClick}
              />

              <DividerIcon />

              <Dropdown 
                menu={{ items: items2 }}
                overlayStyle={{ maxHeight: '400px', overflowY: 'auto', minWidth: '300px' }}
                trigger={['click']}
              >
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                  <BellIcon />
                  {notifications.filter(n => n.status === 'unread').length > 0 && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-4px',
                        right: '-4px',
                        backgroundColor: '#ff4d4f',
                        color: 'white',
                        borderRadius: '50%',
                        width: '18px',
                        height: '18px',
                        fontSize: '11px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}
                    >
                      {notifications.filter(n => n.status === 'unread').length > 9 ? '9+' : notifications.filter(n => n.status === 'unread').length}
                    </span>
                  )}
                </div>
              </Dropdown>

              <DividerIcon />
              <Dropdown menu={{ items: items() }}>
                <UserSvgIcon />
              </Dropdown>

            </Space>
          </div>
        </Col>
      </Row>
      <Modal
          title="Disable OTP"
          open={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
      >
        <Form form={form} layout="vertical">
          <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
              name="totp"
              label="OTP"
              rules={[
                { required: true, message: 'Please input your OTP!' },
                { len: 6, message: 'OTP must be exactly 6 characters' },
                { pattern: /^\d+$/, message: 'OTP must be a number' }
              ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};
